export default __webpack_public_path__ + "locales/sr-Latn-RS/DeleteProfileEverDialog.json?hash=39ad93a00a28d38a3fce78e156a42192";